<template>
  <div id="relatedproduct">
    <section class="site-section subpage-site-section section-related-projects">
      <div class="container">
        <div class="text-left">
          <h2>相关产品</h2>
        </div>
        <div class="row">
          <div
            class="col-lg-3 col-md-4 col-xs-6"
            v-for="(productItem, productIndex) in productList.filter(
              info => info.code !== productCode
            )"
            :key="productIndex"
          >
            <div class="portfolio-item">
              <img
                :src="require('@/assets/img/products/' + productItem.img)"
                class="img-res mx-auto"
                alt=""
              />
              <h4 class="portfolio-item-title">{{ productItem.title }}</h4>
              <router-link class="text-black" :to="productItem.link">
                <i class="fa fa-arrow-right" aria-hidden="true"></i>
              </router-link>
            </div>
            <router-link class="text-center" :to="productItem.link">
              <h3 class="mt-2">{{ productItem.title }}</h3>
            </router-link>
            <!-- /.portfolio-item -->
          </div>
        </div>
      </div>
    </section>
    <!-- /.section-portfolio -->
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "RelatedProduct",
  props: ["productCode"],
  data() {
    return {
      productList: [
        {
          img: "huan-zai-jin.jpg",
          title: "還債金",
          link: "/products/huan-zai-jin",
          code: "huan-zai-jin"
        },
        {
          img: "tai-sui-dian.jpg",
          title: "太歲殿",
          link: "/products/tai-sui-dian",
          code: "tai-sui-dian"
        },
        {
          img: "di-zhu-jin.jpg",
          title: "地主金",
          link: "/products/di-zhu-jin",
          code: "di-zhu-jin"
        },
        {
          img: "nan-dou-liu-xing-yan-shou-deng.jpg",
          title: "南斗六星延壽燈",
          link: "/products/nan-dou-liu-xing-yan-shou-deng",
          code: "nan-dou-liu-xing-yan-shou-deng"
        },
        {
          img: "tai-sui-jin.jpg",
          title: "太歲金",
          link: "/products/tai-sui-jin",
          code: "tai-sui-jin"
        },
        {
          img: "tian-guan-jin.jpg",
          title: "天官金",
          link: "/products/tian-guan-jin",
          code: "tian-guan-jin"
        },
        {
          img: "wan-fo-shen-qi-ye.jpg",
          title: "萬佛神奇液",
          link: "/products/wan-fo-shen-qi-ye",
          code: "wan-fo-shen-qi-ye"
        },
        {
          img: "wan-fo-shen-xiang-you.jpg",
          title: "萬佛神香油",
          link: "/products/wan-fo-shen-xiang-you",
          code: "wan-fo-shen-xiang-you"
        },
        {
          img: "wen-wu-cai-shen-bao-ku.jpg",
          title: "文武財神寶庫",
          link: "/products/wen-wu-cai-shen-bao-ku",
          code: "wen-wu-cai-shen-bao-ku"
        },
        {
          img: "shou-sheng-qian.jpg",
          title: "壽生錢",
          link: "/products/shou-sheng-qian",
          code: "shou-sheng-qian"
        },
        {
          img: "wen-chang-jin.jpg",
          title: "文昌金",
          link: "/products/wen-chang-jin",
          code: "wen-chang-jin"
        },
        {
          img: "zhu-ge-kong-ming-chen-tan-xiang.jpg",
          title: "諸葛孔明沉檀香",
          link: "/products/zhu-ge-kong-ming-chen-tan-xiang",
          code: "zhu-ge-kong-ming-chen-tan-xiang"
        },
        {
          img: "3-he-1-da-zhuan-yun-fa.jpg",
          title: "3合1",
          link: "/products/3-he-1-da-zhuan-yun-fa",
          code: "3-he-1-da-zhuan-yun-fa"
        }
      ]
    };
  },
  components: {},
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/components/products/RelatedProduct.vue